'use client'

import { ChatContact } from 'help/components/ChatContact/ChatContact'
import { ContactModal } from 'help/components/ContactModal/ContactModal'
import { MoreContactOptionsButton } from 'help/components/MoreContactOptionsButton/MoreContactOptionsButton'
import type { ContactMethod } from 'help/services/contactMethods/types'
import { useState } from 'react'

interface MoreHelpContentProps {
	readonly contactMethods?: ContactMethod[]
	readonly additionalInfo?: string
	readonly categoryName?: string
	readonly questionName?: string
	readonly children: React.ReactNode
}

export function MoreHelpContent({
	contactMethods,
	categoryName,
	questionName,
	children,
}: MoreHelpContentProps) {
	const [showContactModal, setShowContactModal] = useState(false)
	const { description: chatDescription, analyticLabel } =
		contactMethods?.find((contactLabel) => contactLabel.type === 'chat') ?? {}

	const isChatEnabled = !!chatDescription && !!analyticLabel

	const handleOpenCloseModal = () => {
		setShowContactModal((prevShowContactModal) => !prevShowContactModal)
	}

	return (
		<>
			{isChatEnabled ? (
				<ChatContact
					description={chatDescription}
					categoryName={categoryName}
					questionName={questionName}
					chatAnalyticLabel={analyticLabel}
					showContact={handleOpenCloseModal}
				/>
			) : (
				<MoreContactOptionsButton
					categoryName={categoryName}
					questionName={questionName}
					showContact={handleOpenCloseModal}
				/>
			)}
			{children && (
				<ContactModal isOpen={showContactModal} onClose={handleOpenCloseModal}>
					{children}
				</ContactModal>
			)}
		</>
	)
}
